import { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import KLayerNavigation from '../components/KLayerNavigation'
import { isUserLoggedIn } from '../helpers'
import { t } from '../locale'
import { User } from '../react-app-env'

function UserShow() {
  const navigate = useNavigate()

  const [user, setUser] = useState({} as User)

  const [isAdmin, setIsAdmin] = useState('')
  const [isActive, setIsActive] = useState('')
  const [isConfirmed, setIsConfirmed] = useState('')
  const [pinCodeSms, setPinCodeSms] = useState('false')
  const [pinCodeEmail, setPinCodeEmail] = useState('false')

  const params: any = useParams()
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/user-admin/user/${params.userId}`)
      .then(r => r.json())
      .then((r: any) => {
        if (!!r.user) {
          const user = r.user as User

          setUser(user)

          const active = user.active ? t('yes') : t('no')
          const confirmed = user.confirmed ? t('yes') : t('no')
          const admin = user.permissions.admin ? t('yes') : t('no')
          const pinOptionsEmail = user.pinCodeOptions.email ? t('email') : ''
          const pinOptionsSms = user.pinCodeOptions.sms ? t('sms') : ''

          setIsActive(active)
          setIsConfirmed(confirmed)
          setIsAdmin(admin)
          setPinCodeEmail(pinOptionsEmail)
          setPinCodeSms(pinOptionsSms)
        }
      })
  }, [params.userId])

  return (
    <Container>
      <Row>
        <div className='sidebar col-md-3 col-lg-2 p-0'>
          <KLayerNavigation logged={isUserLoggedIn()} />
        </div>

        <main className='col-md-9 ms-sm-auto col-lg-10 px-md-4 mb-5 pb-5'>
          <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3'>
            <p className='pe-none text-draft lead fw-bold link-offset-3 link-underline-primary d-block'>
              {t('previewUser')}
            </p>

            <div className='btn-toolbar mb-2 mb-md-0'>
              <Button
                variant='none'
                className='btn-sm btn-outline-primary rounded-pill'
                onClick={() => {
                  navigate('/user/create')
                }}
              >
                <i className='bi bi-plus-circle me-1'></i>
                {t('newUser')}
              </Button>
            </div>
          </div>

          <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-1 pb-2 mb-3 border-bottom'></div>

          <Row className='g-2'>
            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('gender')}</p>
              <p>{user.gender ? t(user.gender) : '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('firstName')}</p>
              <p>{user.firstName || '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('lastName')}</p>
              <p>{user.lastName || '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('email')}</p>
              <p>{user.email || '—'}</p>
            </Col>
          </Row>

          <Row className='g-2 mt-1'>
            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('phone')}</p>
              <p>{user.phone || '—'}</p>
            </Col>
          </Row>

          <Row className='g-2'>
            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('active')}</p>
              <p>{isActive || '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('confirmed')}</p>
              <p>{isConfirmed || '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('admin')}</p>
              <p>{isAdmin || '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('pinCodeOptions')}</p>
              <p>{[pinCodeEmail, pinCodeSms].filter(Boolean).join(', ') || '—'}</p>
            </Col>
          </Row>

          <Row className='g-2'>
            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('createdAt')}</p>
              <p>{user.createdAt ? new Date(user.createdAt).toLocaleString('de') : '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('updatedAt')}</p>
              <p>{user.updatedAt ? new Date(user.updatedAt).toLocaleString('de') : '—'}</p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('lastAccessTime')}</p>
              <p>
                {user.lastAccessTime ? new Date(user.lastAccessTime).toLocaleString('de') : '—'}
              </p>
            </Col>

            <Col xs={12} md={3}>
              <p className='text-primary smaller mb-1'>{t('lastAccessLocation')}</p>
              <p>
                {user.lastAccessLocation
                  ? (user.lastAccessLocation.match(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/) ?? [
                      '—',
                    ])[0]
                  : '—'}
              </p>
            </Col>
          </Row>

          <Row className='gx-2 mb-4'>
            <Col xs={12}>
              <hr className='my-4' />
            </Col>

            <Col xs={6} className='text-start'>
              <Link to='/user' className='btn btn-warning text-white'>
                « {t('back')}
              </Link>
            </Col>

            <Col xs={6} className='text-end'>
              <Link to={`/user/${user._id}/edit`} className='btn btn-success text-white'>
                {t('editUser')} »
              </Link>
            </Col>
          </Row>
        </main>
      </Row>
    </Container>
  )
}

export default UserShow
